import { fetch as router } from "helpers/router";

export const SELECT_CATEGORY = "SELECT_CATEGORY";
export const selectCategory = (category) => ({
  type: SELECT_CATEGORY,
  category,
});

export const SELECT_COUNTRY = "SELECT_COUNTRY";
export const selectCountry = (country) => ({
  type: SELECT_COUNTRY,
  country,
});

export const REQUEST_TIPS = "REQUEST_TIPS";
const requestTips = (category, country) => ({
  type: REQUEST_TIPS,
  category,
  country,
});

export const RECEIVE_TIPS = "RECEIVE_TIPS";
const receiveTips = (json) => ({
  type: RECEIVE_TIPS,
  statistics: json,
  receivedAt: Date.now(),
});

export const fetchTips = (category, country) => {
  const endpoint = router("api.v2.statistics.index");
  return (dispatch) => {
    dispatch(requestTips(category, country));

    const params = [];

    if (category) {
      params.push(`category=${category}`);
    }

    if (country) {
      params.push(`country=${country}`);
    }

    const queryString = params.join("&");

    return fetch(`${endpoint}?${queryString}`, { credentials: "same-origin" })
      .then((response) => response.json())
      .then((json) => {
        // @NOTE: For testing
        // setTimeout(() => dispatch(receiveTips(json)), 1000);
        dispatch(receiveTips(json));
      });
  };
};
